/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountEmail.defs.js'
export * as $defs from './updateAccountEmail.defs.js'
